import { render, staticRenderFns } from "./FactChemistryGroup.vue?vue&type=template&id=256b7352&scoped=true&"
import script from "./FactChemistryGroup.vue?vue&type=script&lang=js&"
export * from "./FactChemistryGroup.vue?vue&type=script&lang=js&"
import style0 from "./FactChemistryGroup.vue?vue&type=style&index=0&id=256b7352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b7352",
  null
  
)

export default component.exports